import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { CodeInputComponent } from 'angular-code-input';

@Component({
  selector: 'app-registration-confirmation',
  templateUrl: './registration-confirmation.component.html',
  styleUrls: ['./registration-confirmation.component.scss']
})
export class RegistrationConfirmationComponent implements OnInit {
  @ViewChild('codeInput') codeInput!: CodeInputComponent;

  verifying = true;
  verified;
  attemptedRetry = false;
  timeUntilCanResendCode = 0;
  resending = false;
  isLoggedIn = false;
  form: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required]],
      code: ['', [Validators.required]],
      userId: ['', [Validators.required]]
    });
  }

  ngOnInit() {
    const code = this.route.snapshot.queryParams.code ?? '';
    const email = this.route.snapshot.queryParams.email;
    const userId = this.route.snapshot.queryParams.id;

    if (email) {
      this.form.setValue({ email, code, userId });
      this.verify();
    } else {
      this.verifying = false;
    }
  }

  verify() {
    this.verifying = true;
    this.authService.validateCode(this.form.getRawValue()).subscribe(
      _ => {
        this.triggerEmailVerifySuccessActions();
      },
      error => {
        this.verifying = false;
        this.verified = false;

        switch (error.status) {
          case 400: break;
          default: {
            this.notificationService.showError('Something went wrong. Please try again');
          }
        }        
      }
    );
  }

  onCodeCompleted(code: string) {
    this.form.controls.code.setValue(code);
    this.verify();
  }

  resendCode() {
    this.attemptedRetry = true;
    this.timeUntilCanResendCode = 30;

    const resendCheck = setInterval(() => {
      this.timeUntilCanResendCode = Math.max(0, this.timeUntilCanResendCode-1);
      if (this.timeUntilCanResendCode === 0) clearInterval(resendCheck);
    }, 1000);

    this.authService.requestCode(this.form.controls.userId.value).subscribe(
      _ => {},
      error => {
        switch(error.status) {
          case 400: {
            if (error.error.message === 'User email is already verified') {
              this.triggerEmailVerifySuccessActions();
            }
            break;
          }
          default: {
            this.notificationService.showError('Something went wrong. Please try again');
          }
        }

      }
    );
  }
  
  triggerEmailVerifySuccessActions() {
    this.verified = true;
    this.verifying = false

    if (this.authService.isAuthenticated() && this.authService.getUserId() === this.form.controls.userId.value) {
      this.isLoggedIn = true;
    }
  }
}
